import { AfterViewInit,  ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AcvisService } from '@app/services/acvis.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'clever-anmeldungsform',
    templateUrl: './anmeldungsform.component.html',
    styleUrls: ['./anmeldungsform.component.scss'],
    standalone: false
})
export class AnmeldungsformComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    @Input() profileForm: FormGroup;
    @Input() travelersForm: FormGroup;
    @Input() forms: number[] = [];
    @Input() asTouched: boolean = false;
    @Input() step: number = 0;
    @Output() sendStep: EventEmitter<number> = new EventEmitter();
    geburtstagdata: string[] = [];
    monatdata: string[] = [];
    jahrdata: string[] = [];
    fromKont: boolean = false;
    countryList: {
        code?: string; // optional
        name?: string; // optional
    }[];

    countryName: string = 'Deutschland';

    stopRendering: boolean = true;

    protected unsubscribe$ = new Subject();
    constructor(
        protected cdr: ChangeDetectorRef,
        protected guardService: AuthGuardService,
        protected acvisService: AcvisService,
    ) { }

    ngOnInit(): void {
        this.initDate();
        this.getCountry();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes?.['step']?.isFirstChange() && changes?.['step']?.currentValue === 0) {
            this.stopRendering = true;
            setTimeout(() => {
                this.stopRendering = false;
                this.cdr.markForCheck();
            }, 100);
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.stopRendering = false;
            this.cdr.markForCheck();
        }, 100);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async initDate() {
        for (let i = 0; i < 31; i++) {
            this.geburtstagdata.push(('00' + (i + 1)).slice(-2));
        }

        for (let i = 0; i < 12; i++) {
            this.monatdata.push(('00' + (i + 1)).slice(-2));
        }

        for (let i = new Date().getFullYear(); i > 1919; i--) {
            this.jahrdata.push(i + '');
        }
        this.cdr.markForCheck();
    }

    async getCountry() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$),
            switchMap((partner: any) => this.acvisService.request({ ref: partner?.xt?.ref }, 'country')),
        ).subscribe(res => {
            if (res?.length > 0) {
                this.countryList = res;
                for (let i = 0; i < this.countryList.length; i++) {
                    this.countryList[i].code = this.countryList[i].code.toLowerCase();
                }
                this.countryList?.sort((a, b) => a.name.localeCompare(b.name));
                this.cdr.markForCheck();
            }
        });
    }

    async changeCountry(ev) {
        this.countryName = 'Deutschland';
        for (let i = 0; i < this.countryList?.length; i++) {
            if (this.countryList[i].code === ev.value) {
                this.countryName = this.countryList[i].name;
                i = this.countryList.length;
            }
        }
        this.profileForm.controls['anmelder_land_name'].setValue(this.countryName);
        this.cdr.markForCheck();
    }

    trackByFn(index, item) {
        return item.code;
    }

    trackByFnC(index, item) {
        return index;
    }

    setDisabled(ev): void {
        if (ev.checked) {
            this.travelersForm.controls['1_anrede'].disable();
            this.travelersForm.controls['1_anrede'].setValue(this.profileForm.controls['anmelder_anrede'].value);
            this.travelersForm.controls['1_vorname'].disable();
            this.travelersForm.controls['1_vorname'].setValue(this.profileForm.controls['anmelder_vorname'].value);
            this.travelersForm.controls['1_name'].disable();
            this.travelersForm.controls['1_name'].setValue(this.profileForm.controls['anmelder_name'].value);

            this.travelersForm.controls['1_geburtstag'].disable();
            this.travelersForm.controls['1_geburtstag'].setValue(this.profileForm.controls['anmelder_geburtstag'].value);

            this.travelersForm.controls['1_monat'].disable();
            this.travelersForm.controls['1_monat'].setValue(this.profileForm.controls['anmelder_monat'].value);

            this.travelersForm.controls['1_jahr'].disable();
            this.travelersForm.controls['1_jahr'].setValue(this.profileForm.controls['anmelder_jahr'].value);
        } else {
            this.travelersForm.controls['1_anrede'].enable();
            this.travelersForm.controls['1_vorname'].enable();
            this.travelersForm.controls['1_name'].enable();
        }
    }

    async getCountryNameFromCode(ev, index) {
        let name = '';
        for (let i = 0; i < this.countryList.length; i++) {
            if (this.countryList[i].code === ev.value) {
                name = this.countryList[i].name;
                i = this.countryList.length;
            }
        }

        this.travelersForm.controls[index + '_land_name'].setValue(name);
    }

    sendLastStep (ss) {
        if (this.step !== ss) {
            this.sendStep.emit(ss);
        }
    }
}
